import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as SocialSecurityCard } from '../../assets/images/svg/ssc.svg';
import themeColors from '../../assets/styles/themeColors';

const SocialSecurityCardStyled = styled(SocialSecurityCard)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const SocialSecurityIcon = (props) => <SocialSecurityCardStyled {...props} />;

SocialSecurityIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

SocialSecurityIcon.defaultProps = {
  w: '25px',
  h: '25px',
};

export default SocialSecurityIcon;
